import { render, staticRenderFns } from "./DeleteInspectionProtocolDialog.vue?vue&type=template&id=09ed12f7&scoped=true"
import script from "./DeleteInspectionProtocolDialog.vue?vue&type=script&lang=js"
export * from "./DeleteInspectionProtocolDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteInspectionProtocolDialog.vue?vue&type=style&index=0&id=09ed12f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ed12f7",
  null
  
)

export default component.exports